import { QueryClient } from '@tanstack/react-query';

// TSS vite/03 §"TanStack Query is the standard".
// Single QueryClient instance, mounted as the 3rd provider layer in app.jsx.

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            // Retry once on network/timeout/5xx, never on a 4xx — a 401 or 403
            // is a decision, not a blip, and retrying it just fires the
            // interceptor's side effect twice. ApiError.isClientError is null-
            // safe for network errors (status === null), so those still retry.
            retry: (failureCount, error) => (error?.isClientError ? false : failureCount < 1),
            refetchOnWindowFocus: true,
            refetchOnReconnect: true,
        },
        mutations: {
            retry: 0,
        },
    },
});
